module.exports = __webpack_public_path__ + "static/media/ico-close.4b318694.svg";